/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-10T11:30:43.725
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getContractSubjectManageEditInit,
	getContractSubjectManageView
} from '@api/storagemanage/ContractSubjectManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getContractSubjectManageEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectManageEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getContractSubjectManageView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectManageView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
